<script>
export default {
   name: 'StageProgress',

   props: {
      activeStage: {
         type: String,
         default: 'CLIENT_INFO_COLLECTION',
      },
      isOpen: {
         type: Boolean,
         default: false,
      },
   },

   computed: {
      isStudyFinished() {
         return this.activeStage === 'DELIVERED';
      },
   },

   data() {
      return {
         stages: [
            {key: 'CLIENT_INFO_COLLECTION', label: 'Client Info Collection'},
            {key: 'RDIG_STUDY_SETUP', label: 'RDIG Study Setup'},
            {key: 'CLIENT_DATA_COLLECTION', label: 'Client Data Collection'},
            {key: 'RDIG_DATA_REVIEW', label: 'RDIG Data Review'},
            {key: 'RDIG_CREDIT_CALCULATION', label: 'RDIG Credit Calculation'},
            {key: 'DELIVERED', label: 'Delivered'},
         ],
      };
   },

   methods: {
      getStageClasses(index, stageKey) {
         const activeIndex = this.stages.findIndex((stage) => stage.key === this.activeStage);
         const currentIndex = this.stages.findIndex((stage) => stage.key === stageKey);

         return {
            'stage__content--open': this.isOpen,
            'bg-success text-white': currentIndex < activeIndex || this.isStudyFinished,
            'bg-primary text-white': currentIndex === activeIndex && !this.isStudyFinished,
            'rounded-left': index === 0,
            'rounded-right': index === this.stages.length - 1,
         };
      },
      getIconPath(stageKey, isIndent) {
         const activeIndex = this.stages.findIndex((stage) => stage.key === this.activeStage);
         const currentIndex = this.stages.findIndex((stage) => stage.key === stageKey);

         if (currentIndex < activeIndex || this.isStudyFinished) {
            return require(isIndent
               ? '@/assets/img/big-indent--success.svg'
               : '@/assets/img/big-pointer--success.svg');
         }
         if (currentIndex === activeIndex && !this.isStudyFinished) {
            return require(isIndent
               ? '@/assets/img/big-indent--primary.svg'
               : '@/assets/img/big-pointer--primary.svg');
         }
         return require(isIndent ? '@/assets/img/big-indent.svg' : '@/assets/img/big-pointer.svg');
      },
      isSuccess(stageKey) {
         const activeIndex = this.stages.findIndex((stage) => stage.key === this.activeStage);
         const currentIndex = this.stages.findIndex((stage) => stage.key === stageKey);

         return currentIndex < activeIndex || this.isStudyFinished;
      },
   },
};
</script>

<template>
   <b-row>
      <b-col
         class="d-flex stage bg-transparent py-3"
         :class="{'stage--open': !!isOpen}"
         style="flex-wrap: wrap; max-width: 100%"
      >
         <span
            v-for="(item, index) in stages"
            :key="item.key"
            class="stage__wrapper"
            :class="{'stage__wrapper--open': !!isOpen}"
         >
            <span v-if="index !== 0" class="stage__arrow stage__arrow--first">
               <img
                  :src="getIconPath(item.key, true)"
                  alt
                  class="stage__arrow__image stage__arrow__image--first"
                  :class="{
                     'stage__arrow__image--first-and-last-stage': index === stages.length - 1,
                  }"
               />
            </span>
            <span :class="getStageClasses(index, item.key)" class="stage__content">
               {{ item.label }}
               <b-icon-check
                  v-if="isSuccess(item.key)"
                  class="stage__check"
                  :class="{'stage__check--last': index === stages.length - 1}"
               ></b-icon-check>
            </span>
            <span v-if="index !== stages.length - 1" class="stage__arrow stage__arrow--last">
               <img
                  :src="getIconPath(item.key, false)"
                  alt
                  class="stage__arrow__image stage__arrow__image--last"
               />
            </span>
         </span>
      </b-col>
   </b-row>
</template>

<style scoped lang="scss">
.stage {
   font-weight: 500;

   &__content {
      position: relative;
      background-color: $stage-bg-default;
      color: $stage-color-default;
      width: 100%;
      display: inline-flex;
      white-space: nowrap;
      font-size: 0.5625rem;
      font-weight: 400;
      justify-content: flex-start;
      padding-left: 0.5rem;
      align-items: center;

      &--open {
         font-size: 0.625rem;
      }
   }

   &__check {
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translate(0%, -50%);
      font-size: 20px;

      &--last {
         right: 0.625rem;
      }
   }

   &__arrow {
      color: transparent;
      text-align: center;
      display: inline-flex;

      &__image {
         display: block;
         height: 100%;
         width: auto;
         pointer-events: none;
         user-select: none;

         &--first {
            margin-right: -1px;
         }
         &--first-and-last-stage {
            margin-right: 0 !important;
            margin-left: 1px;
         }
         &--last {
            margin-left: -1px;
         }
      }
      &--first {
         width: 0.3125rem;
      }
      &--last {
         width: 14px;
         display: block;
         align-items: stretch;
         padding: 0;
         margin: 0;
         height: 100%;
      }
   }

   &__wrapper {
      height: 1.625rem;
      display: flex;
      flex: 0 0 142px;

      &--open {
         height: 2.375rem;
         flex: 0 0 170px;
      }

      @media (max-width: 1404px) {
         margin-bottom: 5px;
      }
   }
}
</style>
